import React from "react";
import { useTranslation } from "react-i18next";
import type { TransformedProduct } from "../../../../types/productApiTypes";
import ReferenceCodes from "../../ReferenceCodes";

interface ProductMetaProps {
  product: TransformedProduct;
  selectedVariation: TransformedProduct | null;
}

/**
 * Renders the product's meta, dynamically showing variation SKU when selected.
 */
const ProductMeta: React.FC<ProductMetaProps> = ({
  product,
  selectedVariation,
}) => {
  const { t } = useTranslation();
  const sku = selectedVariation ? selectedVariation.sku : product.sku;

  return (
    <div className="product-info-details__meta">
      {product.brands.length > 0 && (
        <p>
          <strong>{t("productInfoDetails.brands", "Brands")}:</strong>{" "}
          {product.brands.map((b, index) => (
            <React.Fragment key={b.id}>
              <a href={b.link} className="product-info-details__meta-link">
                {b.name}
              </a>
              {index < product.brands.length - 1 && ", "}
            </React.Fragment>
          ))}
        </p>
      )}
      {product.enrichedCategories.length > 0 && (
        <p>
          <strong>{t("productInfoDetails.categories")}:</strong>{" "}
          {product.enrichedCategories.map((c, index) => (
            <React.Fragment key={c.id}>
              <a href={c.link} className="product-info-details__meta-link">
                {c.name}
              </a>
              {index < product.enrichedCategories.length - 1 && ", "}
            </React.Fragment>
          ))}
        </p>
      )}
      {product.enrichedTags.length > 0 && (
        <p>
          <strong>{t("productInfoDetails.tags")}:</strong>{" "}
          {product.enrichedTags.map((t, index) => (
            <React.Fragment key={t.id}>
              <a
                href={t.link as string}
                className="product-info-details__meta-link"
              >
                {t.name}
              </a>
              {index < product.enrichedTags.length - 1 && ", "}
            </React.Fragment>
          ))}
        </p>
      )}
      {sku && (
        <p>
          <strong>SKU:</strong> {sku}
        </p>
      )}
      <ReferenceCodes product={selectedVariation?.referenceCodes?.length ? selectedVariation : product} />
    </div>
  );
};

export default ProductMeta;
